import { render, staticRenderFns } from "./solicitudForm.vue?vue&type=template&id=57ecbab8"
import script from "./solicitudForm.vue?vue&type=script&lang=js"
export * from "./solicitudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports